(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jsq-atelier-footer"] && !Shopify.designMode) return;
  try {
    (() => {
  const phone = matchMedia('(max-width: 768px)');
  const sync = () => document.querySelectorAll('.jsqa-footer details').forEach(item => { item.open = !phone.matches; });
  sync();
  phone.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judaica-megamenu-original"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.customElements && !customElements.get('judaica-megamenu')) {
      customElements.define('judaica-megamenu', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          var hideTimer = null;
          var activeTrigger = null;
          var suppressFocusOpen = false;
          var triggers = self.querySelectorAll('.jz-mm__trigger[data-target]');
          var panels = self.querySelectorAll('.jz-mm__panel');
          function close(restoreFocus) {
            clearTimeout(hideTimer);
            triggers.forEach(function(trigger) {
              trigger.setAttribute('aria-expanded', 'false');
            });
            panels.forEach(function(panel) {
              panel.classList.remove('is-open');
              panel.setAttribute('hidden', '');
            });
            var triggerToRestore = activeTrigger;
            activeTrigger = null;
            if (restoreFocus && triggerToRestore) {
              suppressFocusOpen = true;
              triggerToRestore.focus();
              suppressFocusOpen = false;
            }
          }
          function scheduleClose() {
            clearTimeout(hideTimer);
            hideTimer = setTimeout(function() { close(false); }, 180);
          }
          function show(id, trigger) {
            clearTimeout(hideTimer);
            activeTrigger = trigger;
            triggers.forEach(function(item) {
              item.setAttribute('aria-expanded', item.dataset.target === id ? 'true' : 'false');
            });
            panels.forEach(function(p){
              var on = p.dataset.panel === id;
              p.classList.toggle('is-open', on);
              if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
            });
          }
          triggers.forEach(function(trigger) {
            var panel = self.querySelector('[data-panel="' + trigger.dataset.target + '"]');
            if (panel) {
              panel.id = 'jz-mm-panel-' + trigger.dataset.target;
              trigger.setAttribute('aria-controls', panel.id);
            }
            trigger.addEventListener('mouseenter', function() { show(trigger.dataset.target, trigger); });
            trigger.addEventListener('focus', function() {
              if (!suppressFocusOpen) show(trigger.dataset.target, trigger);
            });
            trigger.addEventListener('mouseleave', scheduleClose);
            trigger.addEventListener('keydown', function(event) {
              if (event.key !== 'ArrowDown' || !panel) return;
              var firstLink = panel.querySelector('a[href]');
              if (!firstLink) return;
              event.preventDefault();
              show(trigger.dataset.target, trigger);
              firstLink.focus();
            });
          });
          panels.forEach(function(panel) {
            panel.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
            panel.addEventListener('focusin', function() { clearTimeout(hideTimer); });
            panel.addEventListener('mouseleave', scheduleClose);
            panel.addEventListener('focusout', function(event) {
              if (!self.contains(event.relatedTarget)) scheduleClose();
            });
          });
          document.addEventListener('pointerdown', function(event) {
            if (!self.contains(event.target)) close(false);
          });
          document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && activeTrigger) {
              event.preventDefault();
              close(true);
            }
          });
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
